"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAreaLandsHodsCount = exports.getAreaPolygon = exports.getAreaByName = exports.getAreaById = exports.getAreaDetails = exports.getAreas = exports.getAreasByCity = exports.getAreasByCityAndCharacters = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getAreasByCityAndCharacters(_a) {
    var cityId = _a.cityId, chars = _a.chars, areasVersion = _a.areasVersion, purpose = _a.purpose, take = _a.take, skip = _a.skip;
    var where = {
        version: { equals: areasVersion },
        city: {
            is: {
                id: {
                    equals: cityId,
                },
            },
        },
        usedFor: { in: purpose },
    };
    where.name = { contains: chars };
    var variables = {
        where: where,
        take: take,
        skip: skip,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: AreaWhereInput, $take: Int, $skip: Int) {\n        areas(\n          where: $where\n          orderBy: { sequence: desc }\n          take: $take\n          skip: $skip\n        ) {\n          id\n          name\n          keyName\n          searchName\n          lat\n          lng\n          radius\n          keyName\n          zoom\n          city {\n            id\n            name\n            keyName\n          }\n          version\n          usedFor\n          areaInSqKms\n          intro\n          about\n        }\n        areasConnection(where: $where) {\n          _count {\n            id\n          }\n        }\n      }\n    "], ["\n      query($where: AreaWhereInput, $take: Int, $skip: Int) {\n        areas(\n          where: $where\n          orderBy: { sequence: desc }\n          take: $take\n          skip: $skip\n        ) {\n          id\n          name\n          keyName\n          searchName\n          lat\n          lng\n          radius\n          keyName\n          zoom\n          city {\n            id\n            name\n            keyName\n          }\n          version\n          usedFor\n          areaInSqKms\n          intro\n          about\n        }\n        areasConnection(where: $where) {\n          _count {\n            id\n          }\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getAreasByCityAndCharacters = getAreasByCityAndCharacters;
function getAreasByCity(_a) {
    var cityId = _a.cityId, purpose = _a.purpose, areasVersion = _a.areasVersion, orderBy = _a.orderBy, take = _a.take, skip = _a.skip;
    return {
        variables: {
            where: {
                version: {
                    equals: areasVersion,
                },
                city: {
                    is: {
                        id: {
                            equals: cityId,
                        },
                    },
                },
                usedFor: {
                    equals: purpose,
                },
            },
            orderBy: orderBy,
            take: take,
            skip: skip,
        },
        query: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: AreaWhereInput!\n        $orderBy: [AreaOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        areas(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n        }\n      }\n    "], ["\n      query(\n        $where: AreaWhereInput!\n        $orderBy: [AreaOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        areas(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n        }\n      }\n    "]))),
    };
}
exports.getAreasByCity = getAreasByCity;
function getAreas(_a) {
    var name = _a.name, purpose = _a.purpose, areasVersion = _a.areasVersion, citiesVersion = _a.citiesVersion, _b = _a.lang, lang = _b === void 0 ? 'ar' : _b, take = _a.take, skip = _a.skip;
    var whereAreas = {
        version: {
            equals: areasVersion,
        },
        usedFor: {
            in: purpose,
        },
    };
    var whereCities = {
        version: {
            equals: citiesVersion,
        },
    };
    if (lang == 'en') {
        if (Array.isArray(name)) {
            whereAreas.OR = name.map(function (nm) { return ({
                keyName: {
                    contains: nm,
                },
            }); });
            whereCities.OR = whereAreas.OR;
        }
        else {
            whereAreas.keyName = {
                contains: name,
            };
            whereCities.keyName = {
                contains: name,
            };
        }
    }
    else {
        if (Array.isArray(name)) {
            whereAreas.OR = name.map(function (nm) { return ({
                name: {
                    contains: nm,
                },
            }); });
            whereCities.OR = whereAreas.OR;
        }
        else {
            whereAreas.name = {
                contains: name,
            };
            whereCities.name = {
                contains: name,
            };
        }
    }
    return {
        variables: {
            whereAreas: whereAreas,
            whereCities: whereCities,
            take: take || 20,
            skip: skip,
        },
        query: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query(\n        $whereAreas: AreaWhereInput!\n        $whereCities: CityWhereInput!\n        $take: Int\n        $skip: Int\n      ) {\n        areas(\n          where: $whereAreas\n          orderBy: { sequence: desc }\n          take: $take\n          skip: $skip\n        ) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            zoom\n            radius\n          }\n        }\n        cities(where: $whereCities, orderBy: { sequence: desc }, take: 7) {\n          id\n          name\n          keyName\n          lat\n          lng\n          zoom\n          radius\n        }\n      }\n    "], ["\n      query(\n        $whereAreas: AreaWhereInput!\n        $whereCities: CityWhereInput!\n        $take: Int\n        $skip: Int\n      ) {\n        areas(\n          where: $whereAreas\n          orderBy: { sequence: desc }\n          take: $take\n          skip: $skip\n        ) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            zoom\n            radius\n          }\n        }\n        cities(where: $whereCities, orderBy: { sequence: desc }, take: 7) {\n          id\n          name\n          keyName\n          lat\n          lng\n          zoom\n          radius\n        }\n      }\n    "]))),
    };
}
exports.getAreas = getAreas;
function getAreaDetails(_a) {
    var id = _a.id;
    return {
        variables: {
            where: {
                id: {
                    equals: id,
                },
            },
        },
        query: (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      query($where: AreaWhereInput!) {\n        areas(where: $where) {\n          id\n          name\n          keyName\n          population\n          governedByAr\n          areaInSqKms\n          intro\n          about\n        }\n      }\n    "], ["\n      query($where: AreaWhereInput!) {\n        areas(where: $where) {\n          id\n          name\n          keyName\n          population\n          governedByAr\n          areaInSqKms\n          intro\n          about\n        }\n      }\n    "]))),
    };
}
exports.getAreaDetails = getAreaDetails;
function getAreaById(_a) {
    var id = _a.id, areasVersion = _a.areasVersion, purpose = _a.purpose;
    return {
        variables: {
            where: {
                id: {
                    equals: id,
                },
                version: {
                    equals: areasVersion,
                },
                usedFor: {
                    in: purpose,
                },
            },
            take: 1,
        },
        query: (0, graphql_tag_1.default)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      query($where: AreaWhereInput!) {\n        areas(where: $where, orderBy: { sequence: desc }) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          areaPolygon\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            cityPolygon\n            zoom\n            radius\n          }\n        }\n      }\n    "], ["\n      query($where: AreaWhereInput!) {\n        areas(where: $where, orderBy: { sequence: desc }) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          areaPolygon\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            cityPolygon\n            zoom\n            radius\n          }\n        }\n      }\n    "]))),
    };
}
exports.getAreaById = getAreaById;
function getAreaByName(_a) {
    var name = _a.name, isExact = _a.isExact, areasVersion = _a.areasVersion, purpose = _a.purpose;
    var AND = [];
    if (isExact) {
        AND.push({
            name: {
                equals: name,
            },
        });
    }
    else {
        AND.push({
            name: {
                contains: name,
            },
        });
    }
    return {
        variables: {
            where: {
                AND: AND,
                version: {
                    equals: areasVersion,
                },
                usedFor: {
                    in: purpose,
                },
            },
            take: 1,
        },
        query: (0, graphql_tag_1.default)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      query($where: AreaWhereInput!) {\n        areas(where: $where, orderBy: { sequence: desc }) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            zoom\n            radius\n          }\n        }\n      }\n    "], ["\n      query($where: AreaWhereInput!) {\n        areas(where: $where, orderBy: { sequence: desc }) {\n          id\n          name\n          keyName\n          lat\n          lng\n          radius\n          zoom\n          city {\n            id\n            name\n            keyName\n            lat\n            lng\n            zoom\n            radius\n          }\n        }\n      }\n    "]))),
    };
}
exports.getAreaByName = getAreaByName;
function getAreaPolygon(_a) {
    var id = _a.id;
    var variables = {
        where: {
            id: {
                equals: id,
            },
        },
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      query Areas($where: AreaWhereInput) {\n        areas(where: $where) {\n          id\n          areaPolygon\n        }\n      }\n    "], ["\n      query Areas($where: AreaWhereInput) {\n        areas(where: $where) {\n          id\n          areaPolygon\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getAreaPolygon = getAreaPolygon;
function getAreaLandsHodsCount(_a) {
    var countType = _a.countType, where = _a.where;
    var variables = {
        where: where,
    };
    if (countType === 'area') {
        return {
            query: (0, graphql_tag_1.default)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n        query AreasConnection($where: AreaWhereInput) {\n          areasConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "], ["\n        query AreasConnection($where: AreaWhereInput) {\n          areasConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "]))),
            variables: variables,
        };
    }
    else if (countType === 'hod') {
        return {
            query: (0, graphql_tag_1.default)(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n        query HodsConnection($where: HodWhereInput) {\n          hodsConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "], ["\n        query HodsConnection($where: HodWhereInput) {\n          hodsConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "]))),
            variables: variables,
        };
    }
    else if (countType === 'land') {
        return {
            query: (0, graphql_tag_1.default)(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n        query LandsConnection($where: LandsWhereInput) {\n          landsConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "], ["\n        query LandsConnection($where: LandsWhereInput) {\n          landsConnection(where: $where) {\n            _count {\n              id\n            }\n          }\n        }\n      "]))),
            variables: variables,
        };
    }
    else {
        return [];
    }
}
exports.getAreaLandsHodsCount = getAreaLandsHodsCount;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
